function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationReading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "education_x5F_reading",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "30,22 28,22 28,18.744 18,15.744 18,12.586 21,9.586 21,4.414 18.586,2 13.414,2  11,4.414 11,9.586 14,12.586 14,15.744 4,18.744 4,22 2,22 2,17.256 12,14.256 12,13.414 9,10.414 9,3.586 12.586,0 19.414,0  23,3.586 23,10.414 20,13.414 20,14.256 30,17.256  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 22,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 22,
    style: {
      fill: "#FD5C3F"
    },
    width: 7,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 26,
    style: {
      fill: "#FD5C3F"
    },
    width: 9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 26,
    style: {
      fill: "#FD5C3F"
    },
    width: 9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 30,
    style: {
      fill: "#FD5C3F"
    },
    width: 32,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M17,31h-2c0-3.859-3.14-7-7-7v-2C12.962,22,17,26.037,17,31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M18,31h-2c0-4.963,4.038-9,9-9v2C21.14,24,18,27.141,18,31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationReading);
export default __webpack_public_path__ + "static/media/education_reading.43afadc1b68beb70c6e0f3268826fd89.svg";
export { ForwardRef as ReactComponent };